import React, { useEffect, useState, useRef, Fragment } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '../ui/button';
import { MoreVertical } from 'lucide-react';
interface ActionItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  destructive?: boolean;
  separator?: boolean;
}
interface ActionsMenuProps {
  items: ActionItem[];
}
export function ActionsMenu({
  items
}: ActionsMenuProps) {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({
    top: 0,
    left: 0
  });
  const triggerRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node) && triggerRef.current && !triggerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const handleScroll = () => setOpen(false);
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('scroll', handleScroll, true);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('scroll', handleScroll, true);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open]);
  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const menuWidth = 192;
      const spaceBelow = window.innerHeight - rect.bottom;
      const showAbove = spaceBelow < 250;
      setPosition({
        top: showAbove ? rect.top - 8 : rect.bottom + 4,
        left: Math.min(rect.right - menuWidth, window.innerWidth - menuWidth - 8)
      });
    }
    setOpen(!open);
  };
  const menu = open ? createPortal(<div ref={menuRef} className="fixed bg-white rounded-md border shadow-lg py-1 w-48 z-[9999] animate-in fade-in-0 zoom-in-95" style={{
    top: position.top,
    left: position.left
  }} data-id="element-64">
          {items.map((item, i) => <Fragment key={i} data-id="element-65">
              {item.separator && i > 0 && <div className="h-px bg-slate-100 my-1" data-id="element-66" />}
              <button className={`flex items-center w-full px-3 py-2 text-sm transition-colors hover:bg-slate-50 ${item.destructive ? 'text-red-600 hover:bg-red-50' : 'text-slate-700'}`} onClick={e => {
        e.stopPropagation();
        setOpen(false);
        item.onClick();
      }} data-id="element-67">
                {item.icon && <span className="mr-2 shrink-0" data-id="element-68">{item.icon}</span>}
                {item.label}
              </button>
            </Fragment>)}
        </div>, document.body) : null;
  return <>
      <Button ref={triggerRef} variant="ghost" size="icon" className="h-8 w-8" onClick={handleToggle} data-id="element-69">
        <MoreVertical className="h-4 w-4" data-id="element-70" />
      </Button>
      {menu}
    </>;
}